var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_86",
    "data-name": "Group 86",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.598,
    height: 18.615,
    viewBox: "0 0 18.598 18.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M73.957,14.759a2.034,2.034,0,0,0,.085-.4,2.1,2.1,0,0,1,.526-.961c.489-.5.981-.99,1.481-1.476a1.294,1.294,0,0,1,1.455-.366,1.69,1.69,0,0,1,.578.4q1.048,1.047,2.093,2.1a1.417,1.417,0,0,1,.508,1.225,1.577,1.577,0,0,1-.51.9c-.41.412-.824.821-1.236,1.232-.211.211-.214.267-.091.543A10.345,10.345,0,0,0,80.8,20.706a13.164,13.164,0,0,0,2.555,2.172c.332.213.687.381,1.038.56a.3.3,0,0,0,.386-.1c.432-.435.862-.869,1.3-1.3a1.529,1.529,0,0,1,.888-.49,1.267,1.267,0,0,1,.949.274,2.61,2.61,0,0,1,.272.24q1.031,1.026,2.059,2.055a1.839,1.839,0,0,1,.433.6,1.174,1.174,0,0,1-.2,1.276,20.983,20.983,0,0,1-1.708,1.733,2.465,2.465,0,0,1-1.938.543,9.143,9.143,0,0,1-3.4-1.037A17.969,17.969,0,0,1,78.834,24,17.691,17.691,0,0,1,74.488,17.6a7.386,7.386,0,0,1-.5-1.963.374.374,0,0,0-.03-.083Z",
    transform: "translate(-73.957 -9.669)",
    fill: "#bcbcbc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M87.33,8.972c.412.116.838.17,1.251.284a10.687,10.687,0,0,1,7.466,7.582c.065.245.1.5.165.744.029.113-.016.135-.109.15-.389.062-.777.123-1.163.2-.117.022-.143-.014-.163-.118a9.007,9.007,0,0,0-.506-1.738,9.147,9.147,0,0,0-2.722-3.684,9.031,9.031,0,0,0-3.712-1.825,5.429,5.429,0,0,0-.641-.122c-.153-.017-.171-.083-.15-.213.063-.419.117-.839.174-1.258Z",
    transform: "translate(-77.623 -8.972)",
    fill: "#bcbcbc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M86.772,15.495c.06-.425.119-.82.168-1.216.015-.119.068-.125.168-.108a6.2,6.2,0,0,1,2.344.882,6.385,6.385,0,0,1,2.8,3.768c.021.076.038.153.054.23.076.363.075.363-.283.423-.3.052-.61.1-.912.155-.119.023-.167,0-.193-.128a4.78,4.78,0,0,0-1.3-2.467,4.874,4.874,0,0,0-2.645-1.414c-.082-.015-.232.024-.2-.125",
    transform: "translate(-77.547 -10.427)",
    fill: "#bcbcbc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGrey);
export default __webpack_public_path__ + "static/media/phone-grey.3d37e552596ba66cc476646461b84bb1.svg";
export { ForwardRef as ReactComponent };